import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EditAdmin } from '../../../redux/admin/admin_user/adminServicesSync';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { InfinitySpin } from 'react-loader-spinner';

const baseSchema = Yup.object({
  name: Yup.string().required(),
  email: Yup.string().email().required(),
  adminType: Yup.string().required(),
  password: Yup.string(),
  confirm_password: Yup.string().oneOf(
    [Yup.ref('password'), null],
    'Passwords must match'
  ),
  status: Yup.string().required(),
});

const Edit_Admin = () => {
  const dispatch = useDispatch();

  const [active, setActive] = useState(true);

  const { loader, userDetails } = useSelector((state) => state.admin);

  const handleSubmited = async (value, { resetForm }) => {
    // e.preventDefault();
    if (loader) return;

    if (!value.password) {
      delete value.password;
    }

    const payload = {
      ...value,
    };

    await dispatch(EditAdmin({ ...userDetails, ...payload }));

    resetForm();
  };

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    setFieldValue,
  } = useFormik({
    initialValues: {
      name: '',
      email: '',
      role: '',
      adminType: '',
      status: 'active',
      phone_number: '',
      password: '',
    },
    validationSchema: baseSchema,
    onSubmit: handleSubmited,
  });

  useEffect(() => {
    setFieldValue('name', userDetails?.name);

    setFieldValue('email', userDetails?.email);

    setFieldValue('adminType', userDetails?.adminType);

    setFieldValue('status', userDetails?.status);

    setActive(userDetails?.status === 'active' ? true : false);
  }, [userDetails]);

  return (
    <>
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Roles Information</h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  <form>
                    <div class="mb-3">
                      <label for="roles-name" class="form-label">
                        Admin Email
                      </label>
                      <input
                        type="email"
                        id="roles-name"
                        value={values.email || ''}
                        name="email"
                        class="form-control"
                        placeholder="Admin Email"
                        onChange={handleChange}
                      />
                    </div>
                  </form>
                </div>
                <div class="col-lg-6">
                  <form>
                    <div class="mb-3">
                      <label for="workspace" class="form-label">
                        Admin Type
                      </label>
                      <select
                        class="form-control"
                        id="workspace"
                        data-choices
                        data-choices-groups
                        data-placeholder="Select Workspace"
                        value={values.adminType || ''}
                        onChange={(e) =>
                          setFieldValue('adminType', e.target.value)
                        }
                      >
                        <option value="Select Admin"></option>
                        <option value="mid_admin">Mid Admin</option>
                        <option value="order_admin">Order Admin</option>
                        <option value="product_admin">Product Admin</option>
                        <option value="normal_admin">Normal Admin</option>
                      </select>
                    </div>
                  </form>
                </div>
                <div class="col-lg-6">
                  <form>
                    <div class="mb-3">
                      <label for="roles-name" class="form-label">
                        Admin Name
                      </label>
                      <input
                        type="text"
                        id="roles-name"
                        class="form-control"
                        placeholder="Admin Name"
                        name="name"
                        value={values.name || ''}
                        onChange={handleChange}
                      />
                    </div>
                  </form>
                </div>
                <div class="col-lg-6">
                  <form>
                    <div class="mb-3">
                      <label for="roles-name" class="form-label">
                        Password
                      </label>
                      <input
                        type="text"
                        id="roles-name"
                        class="form-control"
                        placeholder="Password"
                        name="password"
                        value={values.password || ''}
                        onChange={handleChange}
                      />
                    </div>
                  </form>
                </div>

                <div class="col-lg-6">
                  <form>
                    <div class="mb-3">
                      <label for="roles-name" class="form-label">
                        Confirm Password
                      </label>
                      <input
                        type="text"
                        id="roles-name"
                        class="form-control"
                        placeholder="Confirm Password"
                        name="confirm_password"
                        value={values.confirm_password || ''}
                        onChange={handleChange}
                      />
                    </div>
                  </form>
                </div>
                <div class="col-lg-6">
                  <p>Admin Status </p>
                  <div class="d-flex gap-2 align-items-center">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault1"
                        checked={active}
                        onChange={(e) => {
                          if (e.target.id === 'flexRadioDefault1') {
                            setActive(e.target.checked);
                            setFieldValue('status', 'active');
                          } else {
                            setActive(!e.target.checked);
                            setFieldValue('status', 'inactive');
                          }
                        }}
                      />
                      <label class="form-check-label" for="flexRadioDefault1">
                        Active
                      </label>
                    </div>

                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault2"
                        checked={!active}
                        onChange={(e) => {
                          if (e.target.id === 'flexRadioDefault2') {
                            setActive(!e.target.checked);
                            setFieldValue('status', 'inactive');
                          } else {
                            setActive(e.target.checked);
                            setFieldValue('status', 'active');
                          }
                        }}
                      />
                      <label class="form-check-label" for="flexRadioDefault2">
                        In Active
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer border-top">
              <a class="btn btn-primary" onClick={handleSubmit}>
                {loader ? (
                  <div>
                    <InfinitySpin width="50" color="#ED1D24" />
                  </div>
                ) : (
                  <>Edit Admin</>
                )}
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Edit_Admin;
